document.addEventListener("DOMContentLoaded", function() {

	const $ =   jQuery.noConflict(),
				sl_info = $('#section__slider-info .slider-info');                

	setTimeout(function() {
		const active_slide_html = $('#section__slider-info .slider-section .swiper-slide-active .wp-block-wp-cta-card.is-style-cta-slider-content .desc').html();
		// console.log(active_slide_html);
		$(sl_info).append( active_slide_html ).fadeIn();

		$('#section__slider-info .slider-section .swiper-slider-section-nav').on('click', function() {
			active_slide_html_next = $('#section__slider-info .slider-section .swiper-slide-active .wp-block-wp-cta-card.is-style-cta-slider-content .desc').html();
			sl_info.empty();
			setTimeout(function() {
				$(sl_info).append( active_slide_html_next ).fadeIn();
			}, 500);
		});

	}, 500);

});